import { Injectable } from '@angular/core';
import { GenericoService } from './generico.service';
import { HttpClient } from '@angular/common/http';
import { Alimento } from '../models/alimento';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable()
export class AlimentoService extends GenericoService<Alimento> {
	constructor(private _httpClient: HttpClient) {
		super(_httpClient, 'alimento');
	}

	getStock(alimentoID, almacenID): Observable<number> {
		return this._httpClient.get<number>(environment.apiUrl + `/${this._endpoint}/stock/${alimentoID}/${almacenID}`, { headers: this._getHeaders });
	} 
}
